export const DIVIDER_STYLE = {
  Round: 'round',
}
